const defaultValues = {
  analytics: "",
  sessionId: "",
  loggedPlatform: "",
  initializeAnalytics: () => {},
};
Object.freeze(defaultValues);

export default defaultValues;
